"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseFrame = void 0;
var CaseFrame = /** @class */ (function () {
    function CaseFrame(terms, env, src) {
        this.terms = terms;
        this.env = env;
        this.src = src;
    }
    CaseFrame.prototype.clone = function () {
        return new CaseFrame(this.terms.map(function (t) { return t.clone(); }), this.env.clone(), this.src);
    };
    return CaseFrame;
}());
exports.CaseFrame = CaseFrame;
